const teamMembers = [
    {
        id: 1,
        name: '王威',
        position: 'CEO',
        department: '',
        description: '',
        expertise: [],
        avatarColor: 'from-violet-500 to-purple-600',
    },
    {
        id: 2,
        name: '刘一帆',
        position: '技术经理',
        department: '研发中心',
        description: '负责核心技术研发与团队管理，拥有丰富互联网开发经验，主导多个核心系统建设，专注高性能架构与产品稳定交付。',
        expertise: ['技术研发', '团队管理', '专注性能', '稳定交付'],
        avatarColor: 'from-blue-500 to-indigo-600',
    },
    {
        id: 3,
        name: '许鹏晖',
        position: '后端架构师',
        department: '研发中心',
        description: '后端架构专家，专注云原生与微服务架构，构建「族语」弹性可扩展的后端服务体系，支撑业务快速增长。',
        expertise: ['微服务架构', '数据安全', '高并发系统', '云原生技术'],
        avatarColor: 'from-cyan-500 to-blue-600',
    },
    {
        id: 4,
        name: '李扬',
        position: '后端架构师',
        department: '研发中心',
        description: '精通高可用分布式系统设计，主导「族语」核心业务逻辑与API架构，保障系统高性能与稳定性。',
        expertise: ['DevOps', '容器化部署', '系统监控', '灾备方案'],
        avatarColor: 'from-teal-500 to-emerald-600',
    },
    {
        id: 5,
        name: '刘安琪',
        position: '后端工程师',
        department: '研发中心',
        description: '专注业务系统研发与服务优化，负责「族语」核心功能开发与接口设计，持续提升系统性能、稳定性与数据处理能力。',
        expertise: ['需求落地', '功能研发', '性能调优', '系统维护'],
        avatarColor: 'from-indigo-500 to-violet-600',
    },
    {
        id: 6,
        name: '黄建',
        position: '安卓工程师',
        department: '研发中心',
        description: '全栈开发专家，8年前端架构经验，精通跨平台开发与安全防护，主导「族语」多端一致体验架构设计。',
        expertise: ['前端安全', '安卓开发', 'Kotlin原生', '性能优化'],
        avatarColor: 'from-orange-500 to-red-600',
    },
    {
        id: 7,
        name: '程勇辉',
        position: '前端工程师',
        department: '研发中心',
        description: '全栈移动开发专家，精通iOS生态与跨端技术，主导「族语」iOS端极致体验与性能优化，打造行业标杆应用。',
        expertise: ['iOS开发', 'Swift原生', '跨端框架', '性能调优'],
        avatarColor: 'from-blue-500 to-cyan-600',
    },
    {
        id: 8,
        name: '刘成',
        position: 'iOS专家',
        department: '研发中心',
        description: 'iOS生态深耕者，资深Swift/OC开发专家，专注高性能原生应用开发，打造「族语」丝滑流畅的移动端体验。',
        expertise: ['Swift开发', 'Objective-C', 'iOS性能', '底层优化'],
        avatarColor: 'from-amber-500 to-orange-600',
    },
    {
        id: 9,
        name: '陈君',
        position: '鸿蒙工程师',
        department: '研发中心',
        description: '资深ArkTS/HarmonyOS应用开发专家，专注原生应用与分布式体验开发，打造「族语」流畅一致的鸿蒙端体验。',
        expertise: ['精通ArkTS', '资深Swift', '开发专家', '原生开发'],
        avatarColor: 'from-red-500 to-rose-600',
    },
    {
        id: 10,
        name: '贺湘',
        position: '测试工程师',
        department: '质量中心',
        description: '资深测试专家，精通全链路质量保障体系，构建「族语」立体化安全测试与压力测试方案，保障产品卓越品质。',
        expertise: ['安全测试', '压力测试', '自动化测试', '质量体系'],
        avatarColor: 'from-green-500 to-emerald-600',
    },
    {
        id: 11,
        name: '涂振武',
        position: '产品经理',
        department: '产品中心',
        description: '10年互联网产品与设计经验，主导多款千万级用户产品设计，精通用户体验与产品创新，专注数字人文产品设计方法论。',
        expertise: ['产品战略', '用户体验', '交互创新', '设计系统'],
        avatarColor: 'from-blue-500 to-indigo-600',
    },
    {
        id: 12,
        name: '朱俊飞',
        position: '产品经理',
        department: '产品中心',
        description: '10年复合型产品专家，兼具ToC互联网产品+ToB企业数字化全盘操盘经验，擅长企业信息化建设、泛娱乐/社交产品全链路规划。',
        expertise: ['复合技能', '全链路规划', '产品专家', '全盘操盘'],
        avatarColor: 'from-purple-500 to-pink-600',
    },
    {
        id: 13,
        name: '姚丽婷',
        position: 'UI设计师',
        department: '产品中心',
        description: '专注用户体验与交互设计，负责「族语」产品体验优化与界面设计，打造简洁、温暖、易用的家庭数字产品。',
        expertise: ['用户体验', '交互设计', '易用性', '产品思维'],
        avatarColor: 'from-pink-500 to-rose-600',
    },
    {
        id: 14,
        name: '彭永乐',
        position: 'UI设计师',
        department: '产品中心',
        description: '深耕品牌视觉与界面设计，负责「族语」视觉体系与设计规范建设，持续塑造温暖、统一、有品质的产品体验。',
        expertise: ['视觉设计', '品牌体系', '设计规范', '品质体验'],
        avatarColor: 'from-fuchsia-500 to-purple-600',
    },
    {
        id: 15,
        name: '余光辉',
        position: '用户运营',
        department: '运营中心',
        description: '专注用户增长与社区运营，负责「族语」用户增长策略、活动策划及用户运营，持续提升用户活跃度与长期价值。',
        expertise: ['用户增长', '社区运营', '活动策划', '用户留存'],
        avatarColor: 'from-orange-500 to-amber-600',
    },
    {
        id: 16,
        name: '岳万林',
        position: '内容运营',
        department: '运营中心',
        description: '专注内容策划与品牌传播，负责「族语」内容生态建设与新媒体运营，持续传递家庭记录与亲情传承的品牌价值。',
        expertise: ['内容策划', '品牌传播', '新媒体运营', '内容生态'],
        avatarColor: 'from-yellow-500 to-orange-600',
    },
    {
        id: 17,
        name: '涂招娣',
        position: '人事',
        department: '综管中心',
        description: '专注人才发展与组织建设，负责「族语」人才引进、员工成长及企业文化建设，与团队共同打造充满活力与创造力的工作环境。',
        expertise: ['人才发展', '组织建设', '员工成长', '企业文化'],
        avatarColor: 'from-rose-500 to-pink-600',
    },
    {
        id: 18,
        name: '张敏',
        position: '财务',
        department: '综管中心',
        description: '专注财务管理与经营支持，负责「族语」财务规划、预算管理及运营分析，为企业健康、稳健发展提供坚实保障。',
        expertise: ['财务规划', '经营分析', '预算管理', '风险控制'],
        avatarColor: 'from-stone-500 to-zinc-600',
    },
    {
        id: 19,
        name: '李佩蓉',
        position: '法务',
        department: '综管中心',
        description: '专注互联网合规与法律风险管理，持续完善「族语」法律保障体系，守护企业规范运营与用户合法权益。',
        expertise: ['合规管理', '法律风险', '合同审核', '权益保障'],
        avatarColor: 'from-slate-500 to-gray-600',
    },
];

export const departments = [
    { key: 'all', label: '全部成员', icon: '👥' },
    { key: '研发中心', label: '研发中心', icon: '💻' },
    { key: '质量中心', label: '质量中心', icon: '✅' },
    { key: '产品中心', label: '产品中心', icon: '💡' },
    { key: '运营中心', label: '运营中心', icon: '📣' },
    { key: '综管中心', label: '综管中心', icon: '🏢' },
];

export default teamMembers;
